import { render, staticRenderFns } from "./targetgroups.vue?vue&type=template&id=4a1fe3fc&"
import script from "./targetgroups.vue?vue&type=script&lang=js&"
export * from "./targetgroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports